var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProductSvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5781 8.52V3.98C22.5781 2.57 21.9381 2 20.3481 2H16.3081C14.7181 2 14.0781 2.57 14.0781 3.98V8.51C14.0781 9.93 14.7181 10.49 16.3081 10.49H20.3481C21.9381 10.5 22.5781 9.93 22.5781 8.52Z",
    stroke: "#2F405A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5781 19.77V15.73C22.5781 14.14 21.9381 13.5 20.3481 13.5H16.3081C14.7181 13.5 14.0781 14.14 14.0781 15.73V19.77C14.0781 21.36 14.7181 22 16.3081 22H20.3481C21.9381 22 22.5781 21.36 22.5781 19.77Z",
    stroke: "#2F405A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0781 8.52V3.98C11.0781 2.57 10.4381 2 8.84813 2H4.80813C3.21812 2 2.57812 2.57 2.57812 3.98V8.51C2.57812 9.93 3.21812 10.49 4.80813 10.49H8.84813C10.4381 10.5 11.0781 9.93 11.0781 8.52Z",
    stroke: "#2F405A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0781 19.77V15.73C11.0781 14.14 10.4381 13.5 8.84813 13.5H4.80813C3.21812 13.5 2.57812 14.14 2.57812 15.73V19.77C2.57812 21.36 3.21812 22 4.80813 22H8.84813C10.4381 22 11.0781 21.36 11.0781 19.77Z",
    stroke: "#2F405A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductSvg);
export default __webpack_public_path__ + "static/media/product_svg.1094eef38d37ab3abf47c2e18dab9677.svg";
export { ForwardRef as ReactComponent };